/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'business-note-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M16.996 18.498l-.02 6.205 6.585-6.587a1.489 1.489 0 0 0 .095-.116h-6.16a.5.5 0 0 0-.5.498z"/><path pid="1" d="M22.5 0h-19A1.502 1.502 0 0 0 2 1.5v22A1.502 1.502 0 0 0 3.5 25h12.476l.02-6.506a1.503 1.503 0 0 1 1.5-1.494H24V1.5A1.502 1.502 0 0 0 22.5 0zm-2 12a.5.5 0 0 1 0 1H8v5h5.5a.5.5 0 0 1 0 1H8v3H7v-3H5.5a.5.5 0 0 1 0-1H7v-5H5.5a.5.5 0 0 1 0-1H7V7H5.5a.5.5 0 0 1 0-1H7V3h1v3h12.5a.5.5 0 0 1 0 1H8v5z"/>'
  }
})
